/*
 * @Description: 定级
 * @Author: chenguobiao
 * @Date: 2021-07-23 16:54:09
 * @LastEditTime: 2022-12-03 19:49:04
 * @LastEditors: chenguobiao
 */
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { SessionStorageItem, Encrypt, Decrypt } from '@/render/utils'
import { gradingAPI } from '@/apis'
const CryptoJS = require('crypto-js')
const newQuestionFlagLSI = new SessionStorageItem({ fieldName: CryptoJS.MD5('newQuestionFlag').toString() })
const testPaperLSI = new SessionStorageItem({ fieldName: CryptoJS.MD5('testPaper').toString() })
const currQuestionIdxLSI = new SessionStorageItem({ fieldName: CryptoJS.MD5('currQuestionIdx').toString() })
const currQuestionTypeIdxLSI = new SessionStorageItem({ fieldName: CryptoJS.MD5('currQuestionTypeIdx').toString() })
const currQuestionLSI = new SessionStorageItem({ fieldName: CryptoJS.MD5('currQuestion').toString(), jsonify: true })
const totalTimeLSI = new SessionStorageItem({ fieldName: CryptoJS.MD5('totalTime').toString() })
const eachTimeLSI = new SessionStorageItem({ fieldName: CryptoJS.MD5('eachTime').toString() })
const testLogUidLSI = new SessionStorageItem({ fieldName: CryptoJS.MD5('testLogUid').toString() })
const uidsLSI = new SessionStorageItem({ fieldName: CryptoJS.MD5('uids').toString() })
const moveModeLSI = new SessionStorageItem({ fieldName: CryptoJS.MD5('moveMode').toString() })
@Module({ namespaced: true })
export default class ExamModule extends VuexModule {
  _newQuestionFlag = typeof newQuestionFlagLSI.get() === 'string' ? (Decrypt(newQuestionFlagLSI.get()) !== 'false') : true
  _testPaper = testPaperLSI.get() ? JSON.parse(Decrypt(testPaperLSI.get())) : {} // 考试卷
  _currQuestionIdx = currQuestionIdxLSI.get() ? Number(Decrypt(currQuestionIdxLSI.get())) : 0 // 当前考题下标
  _currQuestionTypeIdx = currQuestionTypeIdxLSI.get() ? Number(Decrypt(currQuestionTypeIdxLSI.get())) : 0 // 当前考题类型下标
  _currQuestion = currQuestionLSI.get() ? JSON.parse(Decrypt(currQuestionLSI.get())) : {} // 当前考题
  _currQuestionType = '' // 当前考题类型
  _totalTime = totalTimeLSI.get() ? Number(Decrypt(totalTimeLSI.get())) : 0 // 考试剩余总时长
  _eachTime = eachTimeLSI.get() ? Number(Decrypt(eachTimeLSI.get())) : 0 // 考试剩余总时长
  _testLogUid = testLogUidLSI.get() ? Decrypt(testLogUidLSI.get()) : ''
  _uids = uidsLSI.get() ? Decrypt(uidsLSI.get()) : '' // 题目的uid集合
  _moveErrorCount = 0 // 整盘棋走错的次数
  _moveErrorStep = []
  _moveMode = moveModeLSI.get() ? Decrypt(moveModeLSI.get()) : 'drag'
  _voiceToken = ''
  _reportNumber = 0
  get newQuestionFlag() {
    return this._newQuestionFlag
  }
  get testPaper() {
    return this._testPaper
  }
  get currQuestionIdx() {
    return this._currQuestionIdx
  }
  get currQuestionTypeIdx() {
    return this._currQuestionTypeIdx
  }
  get currQuestion() {
    return this._currQuestion
  }
  get currQuestionType() {
    return this._currQuestion.type
  }
  get totalTime() {
    return this._totalTime
  }
  get eachTime() {
    return this._eachTime
  }
  get testLogUid() {
    return this._testLogUid
  }
  get uids() {
    return this._uids
  }
  get moveErrorCount() {
    return this._moveErrorCount
  }
  get moveErrorStep() {
    return this._moveErrorStep
  }
  get moveMode() {
    return this._moveMode
  }
  get voiceToken() {
    return this._voiceToken
  }
  get reportNumber() {
    return this._reportNumber
  }
  @Mutation
  setNewQuestionFlag(data) {
    newQuestionFlagLSI.set(Encrypt(data))
    this._newQuestionFlag = data
  }
  @Mutation
  removeNewQuestionFlag() {
    newQuestionFlagLSI.remove()
    this._newQuestionFlag = true
  }
  @Mutation
  setTestPaper(data) {
    testPaperLSI.set(Encrypt(JSON.stringify(data)))
    this._testPaper = data
  }
  @Mutation
  removeTestPaper() {
    testPaperLSI.remove()
    this._testPaper = {}
  }
  @Mutation
  setCurrQuestionIdx(data) {
    currQuestionIdxLSI.set(Encrypt(data))
    this._currQuestionIdx = data
  }
  @Mutation
  removeCurrQuestionIdx() {
    currQuestionIdxLSI.remove()
    this._currQuestionIdx = 0
  }
  @Mutation
  setCurrQuestionTypeIdx(data) {
    currQuestionTypeIdxLSI.set(Encrypt(data))
    this._currQuestionTypeIdx = data
  }
  @Mutation
  removeCurrQuestionTypeIdx() {
    currQuestionTypeIdxLSI.remove()
    this._currQuestionTypeIdx = 0
  }
  @Mutation
  setCurrQuestion(data) {
    currQuestionLSI.set(Encrypt(JSON.stringify(data)))
    this._currQuestion = data
  }
  @Mutation
  removeCurrQuestion() {
    currQuestionLSI.remove()
    this._currQuestion = {}
  }
  @Mutation
  setTotalTime(data) {
    totalTimeLSI.set(Encrypt(data))
    this._totalTime = data
  }
  @Mutation
  removeTotalTime() {
    totalTimeLSI.remove()
    this._totalTime = 0
  }
  @Mutation
  setEachTime(data) {
    eachTimeLSI.set(Encrypt(data))
    this._eachTime = data
  }
  @Mutation
  removeEachTime() {
    eachTimeLSI.remove()
    this._eachTime = 0
  }
  @Mutation
  setTestLogUid(data) {
    testLogUidLSI.set(Encrypt(data))
    this._testLogUid = data
  }
  @Mutation
  removeTestLogUid() {
    testLogUidLSI.remove()
    this._testLogUid = ''
  }
  @Mutation
  setUids(data) {
    uidsLSI.set(Encrypt(data))
    this._uids = data
  }
  @Mutation
  removeUids() {
    uidsLSI.remove()
    this._uids = ''
  }
  @Mutation
  removeMoveMode() {
    moveModeLSI.remove()
    this._moveMode = 'drag'
  }
  @Mutation
  setMoveErrorCount(data) {
    this._moveErrorCount = data
  }
  @Mutation
  setMoveErrorStep(data) {
    this._moveErrorStep = data
  }
  @Mutation
  setMoveMode(data) {
    moveModeLSI.set(Encrypt(data))
    this._moveMode = data
  }
  @Mutation
  setVoiceToken(data) {
    this._voiceToken = data
  }
  @Mutation
  setReportNumber(data) {
    this._reportNumber = data
  }
  @Action()
  clearGradingData() {
    this.context.commit('removeNewQuestionFlag')
    this.context.commit('removeTestPaper')
    this.context.commit('removeCurrQuestionIdx')
    this.context.commit('removeCurrQuestionTypeIdx')
    this.context.commit('removeCurrQuestion')
    this.context.commit('removeTotalTime')
    this.context.commit('removeEachTime')
    this.context.commit('removeTestLogUid')
    this.context.commit('removeUids')
    this.context.commit('removeMoveMode')
  }
  // 登录
  @Action()
  async getVoiceToken() {
    if (this._voiceToken) return this._voiceToken
    // 登录并保存 token
    const result = await gradingAPI.getVoiceToken()
    this.context.commit('setVoiceToken', result.data ? result.data : null)
    return result.data
  }
}
